import { Stack, Typography } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import useLocales from "src/hooks/useLocales";
import { defaultUser, User } from "src/types/user";

// ----------------------------------------------------------------------

export const EmailRow = () => {
	const { data: user } = useQuery<User>({ queryKey: ["user"], initialData: defaultUser });
	const { translate } = useLocales();
	return (
		<Stack flexDirection={"row"} alignItems={"center"} sx={{ mt: 2 }}>
			<Typography width={200} variant='subtitle1'>
				{translate("profile.email")}
			</Typography>
			<Typography variant='body2'>{user?.email}</Typography>
		</Stack>
	);
};

export default EmailRow;
